import * as index from './components/index.js';
export { default as SBlogger } from './components/SBlogger/SBlogger.js';
export { default as SDevTo } from './components/SDevTo/SDevTo.js';
export { default as SDiaspora } from './components/SDiaspora/SDiaspora.js';
export { default as SDouban } from './components/SDouban/SDouban.js';
export { default as SEmail } from './components/SEmail/SEmail.js';
export { default as SEvernote } from './components/SEvernote/SEvernote.js';
export { default as SFacebook } from './components/SFacebook/SFacebook.js';
export { default as SFacebookCount } from './components/SFacebookCount/SFacebookCount.js';
export { default as SFacebookMessenger } from './components/SFacebookMessenger/SFacebookMessenger.js';
export { default as SFacebookWorkplace } from './components/SFacebookWorkplace/SFacebookWorkplace.js';
export { default as SFlipBoard } from './components/SFlipBoard/SFlipBoard.js';
export { default as SGithub } from './components/SGithub/SGithub.js';
export { default as SGithubCount } from './components/SGithubCount/SGithubCount.js';
export { default as SGithubGist } from './components/SGithubGist/SGithubGist.js';
export { default as SGithubGistCount } from './components/SGithubGistCount/SGithubGistCount.js';
export { default as SGithubRepo } from './components/SGithubRepo/SGithubRepo.js';
export { default as SGithubRepoCount } from './components/SGithubRepoCount/SGithubRepoCount.js';
export { default as SGmail } from './components/SGmail/SGmail.js';
export { default as SGoogleBookmarks } from './components/SGoogleBookmarks/SGoogleBookmarks.js';
export { default as SHackerNews } from './components/SHackerNews/SHackerNews.js';
export { default as SHatena } from './components/SHatena/SHatena.js';
export { default as SHatenaCount } from './components/SHatenaCount/SHatenaCount.js';
export { default as SHouzz } from './components/SHouzz/SHouzz.js';
export { default as SInstaPaper } from './components/SInstaPaper/SInstaPaper.js';
export { default as SKakaoStory } from './components/SKakaoStory/SKakaoStory.js';
export { default as SLine } from './components/SLine/SLine.js';
export { default as SLineCount } from './components/SLineCount/SLineCount.js';
export { default as SLinkedIn } from './components/SLinkedIn/SLinkedIn.js';
export { default as SLiveJournal } from './components/SLiveJournal/SLiveJournal.js';
export { default as SMailRu } from './components/SMailRu/SMailRu.js';
export { default as SMicrosoftTeams } from './components/SMicrosoftTeams/SMicrosoftTeams.js';
export { default as SOdnoklassniki } from './components/SOdnoklassniki/SOdnoklassniki.js';
export { default as SOdnoklassnikiCount } from './components/SOdnoklassnikiCount/SOdnoklassnikiCount.js';
export { default as SPinterest } from './components/SPinterest/SPinterest.js';
export { default as SPinterestCount } from './components/SPinterestCount/SPinterestCount.js';
export { default as SPocket } from './components/SPocket/SPocket.js';
export { default as SQZone } from './components/SQZone/SQZone.js';
export { default as SReddit } from './components/SReddit/SReddit.js';
export { default as SRedditCount } from './components/SRedditCount/SRedditCount.js';
export { default as SRenRen } from './components/SRenRen/SRenRen.js';
export { default as SSkype } from './components/SSkype/SSkype.js';
export { default as SSms } from './components/SSms/SSms.js';
export { default as STelegram } from './components/STelegram/STelegram.js';
export { default as SThreema } from './components/SThreema/SThreema.js';
export { default as STrello } from './components/STrello/STrello.js';
export { default as STumblr } from './components/STumblr/STumblr.js';
export { default as STumblrCount } from './components/STumblrCount/STumblrCount.js';
export { default as STwitter } from './components/STwitter/STwitter.js';
export { default as SViber } from './components/SViber/SViber.js';
export { default as SVkontakte } from './components/SVkontakte/SVkontakte.js';
export { default as SVkontakteCount } from './components/SVkontakteCount/SVkontakteCount.js';
export { default as SWeibo } from './components/SWeibo/SWeibo.js';
export { default as SWhatsApp } from './components/SWhatsApp/SWhatsApp.js';
export { default as SWordPress } from './components/SWordPress/SWordPress.js';
export { default as SXing } from './components/SXing/SXing.js';
export { default as SYahoo } from './components/SYahoo/SYahoo.js';
export { default as SYammer } from './components/SYammer/SYammer.js';

/**
 * Import vue components
 */
/**
 * Install function executed by Vue.use()
 */

var install = function installVueSocials(Vue) {
  Object.entries(index).forEach(function (item) {
    Vue.component(item[0], item[1]);
  });
};

export default install;
